import * as api from "./apiUtils";
const baseUrl = api.apiUrl + "progression";

export async function getProgressions(userId) {
    return api.getAsync(baseUrl, userId);
}

export async function getLastProgression(userId) {
    return api.getAsync(`${baseUrl}/getLast`, userId);
}

export async function addProgression(profile) {
    return api.postAsync(baseUrl, profile);
}